import { Backdrop } from '@mui/material';
import { PortalUiLottieLoading } from '@vs/ui/portal/lottie-loading';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import styles from './portal-backdrop.module.css';

enum BackdropType {
  loading = 'loading',
  app_init = 'app_init',
  module_init = 'module_init',
  module_init_mask = 'module_init_mask',
}

/* eslint-disable-next-line */
export interface PortalBackdropProps {
  type: keyof typeof BackdropType;
  open?: boolean;
}

export function PortalBackdrop({ type, open = true }: PortalBackdropProps) {
  const { t } = useTranslation('shared');
  const lottie = (
    <div
      data-testid="vs-lottie-loading"
      className={classNames(styles['loading'], 'z-10')}
      role="status"
      aria-label={t('aria_label.loading')}
    >
      <PortalUiLottieLoading size={40} />
    </div>
  );
  return type === 'module_init' || type === 'module_init_mask'
    ? open && (
        <div className="flex h-full w-full items-center justify-center relative">
          {type === 'module_init_mask' && (
            <div className="bg-vs-neut-1000 opacity-20 absolute top-0 left-0 w-full h-full z-0" />
          )}
          {lottie}
        </div>
      )
    : createPortal(
        <Backdrop
          open={open}
          className={styles['overwrite']}
          invisible={type === 'app_init'}
        >
          {lottie}
        </Backdrop>,
        document.body
      );
}

export default PortalBackdrop;
